import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { QueryIsCartEligibleForCheckoutArgs } from '@hdms/shared/common-types';

interface QueryIsCartEligibleForCheckoutPayload {
  isCartEligibleForCheckout: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CartPaymentEligibilityGqlService extends Query<
  QueryIsCartEligibleForCheckoutPayload,
  QueryIsCartEligibleForCheckoutArgs
> {
  override document = gql`
    query IsCartEligibleForCheckout($cartId: ID!) {
      isCartEligibleForCheckout(cartId: $cartId)
    }
  `;
}
